<template>
  <div>
    <v-layout
      v-if="isEdit"
      class="day-time-picker-layout"
      :style="$vuetify.breakpoint.xsOnly ? 'width: 100%' : 'width: 50%'"
    >
      <v-flex xs4>
        <span>วัน</span>
        <v-select
          placeholder="วัน"
          v-model="followUpWithinMinutes.days"
          @change="(value) => onChanged(value, 'days')"
          :items="Array.from({length: 7}, (_, index) => index)"
          outline
        />
      </v-flex>
      <v-flex xs4>
        <span>ชั่วโมง</span>
        <v-select
          placeholder="ชั่วโมง"
          v-model="followUpWithinMinutes.hours"
          @change="(value) => onChanged(value, 'hours')"
          :items="Array.from({length: 24}, (_, index) => index)"
          outline
        />
      </v-flex>
      <v-flex xs4>
        <span>นาที</span>
        <v-select
          placeholder="นาที"
          v-model="followUpWithinMinutes.minutes"
          @change="(value) => onChanged(value, 'minutes')"
          :items="Array.from({length: 6}, (_, index) => index * 10)"
          outline
        />
      </v-flex>
    </v-layout>
    <p v-else>{{ followUpWithinString }}</p>
  </div>
</template>

<script>
export default {
  props: ['value', 'isEdit'],
  methods: {
    transformFollowUpWithInMinutes() {
      const value = this.value

      const minutesInDay = 24 * 60
      const days = Math.floor(value / minutesInDay)
      const hours = Math.floor((value % minutesInDay) / 60)
      const minutes = value % 60

      return { days, hours, minutes }
    },
    onChanged(value, unit) {
      let data = this.transformFollowUpWithInMinutes()

      data[unit] = value

      const { days, hours, minutes } = data
      const followUpWithinMinutes = (days * 24 * 60) + (hours * 60) + minutes
      
      this.$emit('input', followUpWithinMinutes)
    }
  },
  computed: {
    followUpWithinMinutes() {
      return this.transformFollowUpWithInMinutes()
    },
    followUpWithinString() {
      const { days, hours, minutes } = this.transformFollowUpWithInMinutes()

      const elements = []

      if (days) elements.push(`${days} ${this.$t('day')}`)
      if (hours) elements.push(`${hours} ${this.$t('hour')}`)
      if (minutes) elements.push(`${minutes} ${this.$t('minute')}`)

      return elements.join(' ')
    },
  }
}
</script>

<style scoped>
.day-time-picker-layout {
  gap: 8px;
}
</style>


// WEBPACK FOOTER //
// src/components/view/ZervaConnect/ZervaConnectDayTimePicker.vue